var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4366 0.833344C12.4592 0.900947 11.3169 1.52657 10.6511 2.34125C10.0438 3.0803 9.54426 4.178 9.73905 5.24476C10.807 5.27799 11.9104 4.63748 12.5498 3.80905C13.1479 3.03791 13.6005 1.94708 13.4366 0.833344Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2992 6.85967C16.3608 5.68291 15.0419 5 13.7964 5C12.1522 5 11.4566 5.78718 10.3143 5.78718C9.13634 5.78718 8.24146 5.00229 6.81949 5.00229C5.42273 5.00229 3.93545 5.85593 2.99244 7.31571C1.66672 9.37132 1.89359 13.2362 4.04201 16.5281C4.81086 17.706 5.83752 19.0306 7.18042 19.0421C8.37552 19.0535 8.71239 18.2755 10.3314 18.2675C11.9505 18.2583 12.2576 19.0524 13.4504 19.0398C14.7944 19.0295 15.8772 17.5617 16.6461 16.3838C17.1972 15.5393 17.4023 15.1142 17.8297 14.1609C14.7211 12.9772 14.2227 8.55664 17.2992 6.85967Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.6abff2007b4be48dfdea00ffbb5b2e4f.svg";
export { ForwardRef as ReactComponent };